var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 0.5375,
    y: 0.5375,
    width: 94.925,
    height: 94.925,
    rx: 47.4625,
    fill: "#247DD0",
    stroke: "#E9E9E9",
    strokeWidth: 1.075
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9992 54.8987C55.8688 54.8987 62.2483 48.5192 62.2483 40.6496C62.2483 32.78 55.8688 26.4004 47.9992 26.4004C40.1296 26.4004 33.75 32.78 33.75 40.6496C33.75 48.5192 40.1296 54.8987 47.9992 54.8987Z",
    stroke: "#247DD0",
    strokeWidth: 1.075,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3984 67.3644C28.5883 63.574 31.737 60.4267 35.5283 58.2385C39.3197 56.0503 43.6201 54.8984 47.9975 54.8984C52.375 54.8985 56.6754 56.0505 60.4667 58.2387C64.258 60.427 67.4066 63.5744 69.5964 67.3648",
    stroke: "#247DD0",
    strokeWidth: 1.075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d38e67c0719ec87727ce3422a2ce2bf0.svg";
export { ForwardRef as ReactComponent };